import React from 'react';
import { Link } from 'react-router-dom';
import MainMenu from './mainmenu';
import SideBar from './SideBar';
import { useState, useEffect } from 'react';

export default function HeaderFive() {
	useEffect(() => {
        window.addEventListener('scroll', isSticky);
        return () => {
            window.removeEventListener('scroll', isSticky);
        };
    });           
    /* Method that will fix header after a specific scrollable */
	const isSticky = (e) => {
		const header = document.querySelector('.main-header-area');
		const scrollTop = window.scrollY;
		scrollTop >= 250 ? header.classList.add('sticky-menu') : header.classList.remove('sticky-menu');
	};
	const openSideBar = () =>{
		document.body.classList.add('on-side');
		document.offcanvas.classList.add('show');
	}
	
  return (
    <>
	<div className="body-overlay activemode"></div>
	<SideBar/>
    <header class="header-top-area home-5">
		<div class="container d-none d-sm-block">
			<div class="header-top">
				<ul class="right-query d-flex align-items-center">
					<li>
						<div class="icon"><i class="fas fa-phone"></i></div>
						<div class="query-list">
							<a href="#" class="text-heding4">890. 908. 645. 45</a>
						</div>
					</li>
					<li>
						<div class="icon"><i class="fas fa-envelope"></i></div>
						<div class="query-list">
							<a href="#" class="text-heding4">info@webmail.com</a>
						</div>
					</li>
				</ul>

				<ul class="social-icon">
					<li>
						<a href="#"><i class="fab fa-facebook"></i></a>
					</li>
					<li>
						<a href="#"><i class="fab fa-twitter"></i></a>
					</li>
					<li>
						<a href="#"><i class="fab fa-youtube"></i></a>
					</li>
					<li>
						<a href="#"><i class="fab fa-linkedin"></i></a>
					</li>
					<li>
						<a href="#"><i class="fab fa-behance"></i></a>
					</li>
				</ul>
			</div>
		</div>
		<div id="hideshow-sticky-menu">
			<div class="main-header-area menu-style-6">
				<div class="header-inner menu-sticky sticky">
					<div class="container">
						<div class="menu-area">
							<div class="logo-area">
								<div class="custom-logo-area">
									<Link to="/">
										<img src="assets/img/home-5/header-logo-3.png" alt="" />
									</Link>
								</div>
								<div class="custom-sticky-logo">
									<Link htoref="/">
										<img src="assets/img/home-5/header-logo-1.png" alt="" />
									</Link>
								</div>
							</div>

							<MainMenu/>

							<ul class="right-nav mb-0 d-flex align-items-center justify-content-end">
								<li>
									<div class="hamburger-menu">
										<a  onClick={openSideBar} class="menu-button" herf="#">
											<span class="dot1"></span>
											<span class="dot2"></span>
											<span class="dot3"></span>
											<span class="dot4"></span>
										</a>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	
	</header>
    </>
  )
}
